/**
 * 公開先の origin。
 *
 * **index.html の canonical / og:url / og:image / twitter:image と同じドメインを指す。**
 * ドメインを変えるときは **index.html の4箇所とここ（計5箇所）を一緒に直す**こと。
 * CLAUDE.md のデプロイ節にも同じ注意が書いてある。
 *
 * **なぜ `window.location` を使わないか**（2026-08-17 プリレンダー導入時）:
 * ビルド時のプリレンダーは Node で走るので `window` が無い。以前は
 * `typeof window !== 'undefined' ? window.location.href : ''` としていたが、これだと
 *
 *   - **静的 HTML に空の共有リンクが焼かれる**（`?url=` が空のまま配信される）
 *   - サーバとブラウザで描画結果が食い違い、hydration がずれる
 *
 * の2つが起きる。共有リンクは `href` 属性として実際に描画されるため、
 * **両環境で同じ値になる必要がある**。
 */
export const SITE_ORIGIN = 'https://music.gysakai.com';
